import React from 'react';
import { Alert } from 'reactstrap';

import Icon, { faCircleExclamation } from '~components/icon';

type AlertColor = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

interface ComponentProps {
  header: string;
  color: AlertColor;
  listItems: string[];
}

const AlertList: React.FC<ComponentProps> = ({ header, color, listItems }) => {
  return (
    <Alert color={color} className="w-100 mb-3">
      <Icon icon={faCircleExclamation} className="me-2" />
      <b>{header}</b>
      <div className="mt-2 mb-0">
        <ul>
          {listItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </Alert>
  );
};

export default AlertList;
